import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileDownloadUploadService } from '../../services';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialogComponent implements OnInit {
  accept: any;
  isLoading = false;
  title: string;
  result = { status: 200, message: '' };
  @ViewChild('file', { static: true }) file: HTMLInputElement;
  constructor(public dialogRef: MatDialogRef<FileUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      url,
      accept,
      title
    }, private fileService: FileDownloadUploadService) {
    this.accept = data.accept || '.pdf,.xlsx,.docx'
    this.title = data.title || 'UPLOAD_FILE'
  }

  ngOnInit(): void {

  }
  fileChangeEvent(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    if (element.files.length > 0) {
      this.result.message = '';
    }
  }
  close() {
    this.dialogRef.close({ success: false });
  }
  uploadFile(file) {
    this.result.message = '';
    console.log(this.file.files)
    const item = file.files ? file.files[0] : null;
    const reader = new FileReader();
    if (item == null) {
      this.result.message = 'Файл не выбран';
      this.result.status = 400;
      return;
    }
    reader.readAsDataURL(item);

    reader.onload = (e) => {
      // const encodedFile: any = (e.target as any).result;
      this.isLoading = true;

      setTimeout(() => {
        this.fileService.upload(this.data.url, item)
          .subscribe({
            next: result => {
              this.result.status = 200
              this.result.message = result.message || "Загрузка файл успешно";
              setTimeout(() => {
                this.dialogRef.close({ success: true, result })
              }, 2000)
            }, error: (e: any) => {
              console.log(e)
              this.isLoading = false;
              this.result.status = 400
              this.result.message = e.message || e.error || e
            }, complete: () => {
              this.isLoading = false;
            }
          });

      }, 1000)
    };
  }
}
